import { forwardRef } from "react";
import { TextField as MuiTextField } from "@mui/material";
import type { ProcessedFormField } from "@/types/api/formSchema";

type Props = {
  field: ProcessedFormField;
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  name: string;
};

export const TextField = forwardRef<HTMLInputElement, Props>(function TextField(
  { field: schemaField, value, onChange, onBlur, name },
  ref,
) {
  // type="text" for email fields — Chrome autofill groups type="email" inputs across the form.
  const inputType = schemaField.type === "link" ? "url" : "text";

  return (
    <MuiTextField
      inputRef={ref}
      id={name}
      name={name}
      type={inputType}
      value={value ?? ""}
      placeholder={
        schemaField.placeholder ?? `Enter ${schemaField.resolvedLabel}`
      }
      disabled={!!schemaField.disabled}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      inputProps={{
        autoComplete: name,
        ...(schemaField.type === "email" ? { inputMode: "email" as const } : {}),
        ...(schemaField.maxLength ? { maxLength: schemaField.maxLength } : {}),
        ...(schemaField.noPaste
          ? {
              onPaste: (e: React.ClipboardEvent) => e.preventDefault(),
              onCopy: (e: React.ClipboardEvent) => e.preventDefault(),
              onCut: (e: React.ClipboardEvent) => e.preventDefault(),
              onDrop: (e: React.DragEvent) => e.preventDefault(),
            }
          : {}),
      }}
      fullWidth
      size="small"
      variant="outlined"
    />
  );
});
